var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCreditOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 91,
    viewBox: "0 0 112 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8682 22.3999H11.7318C5.26297 22.3999 0 27.6913 0 34.195V78.9837C0 85.4875 5.26297 90.7789 11.7318 90.7789H77.8682C84.337 90.7789 89.6 85.4875 89.6 78.9837V34.195C89.6 27.6913 84.337 22.3999 77.8682 22.3999ZM11.7292 29.5796H77.8657C80.3967 29.5796 82.4564 31.6504 82.4564 34.195V44.624H7.13854V34.195C7.13854 31.6504 9.19823 29.5796 11.7292 29.5796ZM11.7292 83.5992H77.8657C80.3967 83.5992 82.4564 81.5284 82.4564 78.9837V61.291H7.13854V78.9837C7.13854 81.5284 9.19823 83.5992 11.7292 83.5992Z",
    fill: "#EB5E35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.7336,
    cy: 24.2668,
    r: 16.8,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4446 13.8445H85.4002V21.9334H77.3113V25.9778H85.4002V34.0667H89.4446V25.9778H97.5335V21.9334H89.4446V13.8445ZM87.4224 3.7334C76.2598 3.7334 67.2002 12.793 67.2002 23.9556C67.2002 35.1183 76.2598 44.1778 87.4224 44.1778C98.5851 44.1778 107.645 35.1183 107.645 23.9556C107.645 12.793 98.5851 3.7334 87.4224 3.7334ZM87.4224 40.1334C78.5044 40.1334 71.2446 32.8736 71.2446 23.9556C71.2446 15.0376 78.5044 7.77784 87.4224 7.77784C96.3404 7.77784 103.6 15.0376 103.6 23.9556C103.6 32.8736 96.3404 40.1334 87.4224 40.1334Z",
    fill: "#EB5E35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCreditOrange);
export default __webpack_public_path__ + "static/media/PlusCreditOrange.9ca7c7d4.svg";
export { ForwardRef as ReactComponent };